import styled from 'styled-components';
import {
  AccordionItem,
  paletteHelper,
  radiusHelper,
  typographyHelper,
  spacingHelper,
  Tooltip,
  Accordion,
} from '@property.com.au/ui-kit';
import { DynamicContent } from '../../../../../app-kit/components/DynamicContent/DynamicContent';

export const StyledAccordion = styled(Accordion)`
  margin: ${spacingHelper('small')} 0;
`;

export const StyledOverlayDetails = styled(AccordionItem)`
  background-color: ${paletteHelper('backgroundOrangeSecondary')};
  border-radius: ${radiusHelper('medium')};
  padding: ${spacingHelper('extraSmall')};
  border: none;
  color: ${paletteHelper('textOrange')};

  h3 p {
    ${typographyHelper('subtitle02')};
  }

  h4 {
    ${typographyHelper('body02Bold')};
  }

  p {
    color: ${paletteHelper('textOrange')};
  }

  &:hover {
    background-color: ${paletteHelper('backgroundOrangeSecondary')};
  }

  button:hover:enabled {
    background-color: ${paletteHelper('backgroundOrangeSecondary')};
  }

  &:last-of-type {
    border: none;
  }
`;

export const OverlayList = styled.div`
  margin-top: ${spacingHelper('medium')};
`;

export const OverlayItem = styled.div`
  margin-bottom: ${spacingHelper('small')};

  h4 {
    margin-bottom: ${spacingHelper('twoExtraSmall')};
    display: flex;
    align-items: center;
    gap: ${spacingHelper('twoExtraSmall')};
  }

  li {
    margin-left: -16px;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledTooltip = styled(Tooltip)`
  ${typographyHelper('body01')};

  .triggerButton {
    color: ${paletteHelper('textOrange')};
  }
`;

export const Description = styled(DynamicContent)`
  color: ${paletteHelper('textWarning')};
  ${typographyHelper('body02')};

  &[href] {
    ${typographyHelper('body02Bold')};
    color: ${paletteHelper('textPrimary')};
  }
`;
